module.exports = __webpack_public_path__ + "static/img/sxjzBanner.b809d674.png";